/**a
 * Created by Bart Decorte
 * Date: 2019-08-20
 * Time: 11:16
 */
import SubmitButtonManager from "../helpers/SubmitButtonManager";

const EventEmitter = require('events');

export default class DropzoneModal extends EventEmitter {
  constructor(rootEl, dropzone) {
    super();
    this.rootEl = rootEl;
    const modalId = this.rootEl.id;
    this.idle = true;
    this.dropzone = dropzone;
    this.bindListeners();

    this.submitButtonManager = new SubmitButtonManager({
      buttonSelector: `#${modalId} .js-btn-upload`,
      $form: $(this.formEl()),
      stateEmitter: this,
      onActualSubmit: () => {
        this.submitForm();
      },
    });
  }

  bindListeners() {
    this.dropzone.on('success', (data) => this.lDropzoneSucceeded(data));
    this.dropzone.on('change', () => this.lDropzoneChanged());
    this.dropzone.on('cancellation', () => this.lDropzoneCancelled());
    this.dropzone.on('failure', () => this.lDropzoneFailed());
  }

  lDropzoneSucceeded(result) {
    this.idle = true;
    this.emitIdle()
  }

  lDropzoneChanged() {
    this.idle = false;
    this.emitBusy();
  }

  lDropzoneCancelled() {
    this.idle = true;
    this.emitIdle();
  }

  lDropzoneFailed() {
    this.idle = true;
    this.emitIdle();
  }

  emitBusy() {
    this.emit('busy');
  }

  emitIdle() {
    this.emit('idle');
  }

  isIdle() {
    return this.idle;
  }

  submitForm() {
    document.createElement('form').submit.call(this.formEl());
  }

  dropzoneEl() {
    return this.rootEl.querySelector('.js-dropzone-wrap');
  }

  formEl() {
    return this.rootEl.querySelector('form');
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/modals/DropzoneModal.js